interface StockBadgeProps {
  qty: number | null;
  className?: string;
  // Product grid cards only want the "can't buy this" signal — a healthy
  // or low-but-available stock count isn't worth a badge on every card.
  // The product detail page keeps the full three-state badge (including
  // the low-stock urgency nudge), since that's more useful right before
  // add-to-cart.
  onlyOutOfStock?: boolean;
}

const LOW_STOCK_THRESHOLD = 10;

export default function StockBadge({ qty, className = '', onlyOutOfStock = false }: StockBadgeProps) {
  if (qty === null) return null;
  if (onlyOutOfStock && qty > 0) return null;

  if (qty <= 0) {
    return (
      <span className={`inline-flex items-center gap-1.5 text-[10px] tracking-[0.08em] uppercase px-2.5 py-1 rounded-full bg-[#7B1113]/10 text-[#7B1113] font-semibold ${className}`}>
        <i className="ri-close-circle-line" /> Out of Stock
      </span>
    );
  }

  if (qty <= LOW_STOCK_THRESHOLD) {
    return (
      <span className={`inline-flex items-center gap-1.5 text-[10px] tracking-[0.08em] uppercase px-2.5 py-1 rounded-full bg-[#D4A017]/10 text-[#D4A017] font-semibold ${className}`}>
        <i className="ri-error-warning-line" /> Only {qty} left in stock
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1.5 text-[10px] tracking-[0.08em] uppercase px-2.5 py-1 rounded-full bg-[#2D6A4F]/10 text-[#2D6A4F] font-semibold ${className}`}>
      <i className="ri-checkbox-circle-line" /> In Stock
    </span>
  );
}
